<template>
  <div class="date-range-picker-shortcuts" v-if="isShow">
    <b-nav small>
      <b-nav-item :disabled="shortcut === 'w'" @click="handleDPLastWeek">{{translate('dateRangePicker.lastWeek')}}</b-nav-item>
      <b-nav-item :disabled="shortcut === 'm'" @click="handleDPLastMonth">{{translate('dateRangePicker.lastMonth')}}</b-nav-item>
      <b-nav-item :disabled="shortcut === 'y'" @click="handleDPLastYear">{{translate('dateRangePicker.lastYear')}}</b-nav-item>
    </b-nav>
  </div>
</template>

<script>
  import i18n from '@/i18n/i18n';

  export default {
    name: 'date-range-picker-shortcuts',
    data() {
      return {
        shortcut: null,
        isShow: false
      }
    },
    methods: {
      showShortcuts() {
        this.isShow = true;
      },

      hideShortcuts() {
        this.isShow = false;
      },

      clearShortcut() {
        this.shortcut = null;
      },

      handleDPLastWeek() {
        const weekAgo = new Date();
        weekAgo.setDate(weekAgo.getDate() - 7)
        const dateRange = {
          start: weekAgo,
          end: new Date()
        };
        this.shortcut = 'w';
        this.$emit('changeDateRange', dateRange);
      },

      handleDPLastMonth() {
        const monthAgo = new Date();
        monthAgo.setMonth(monthAgo.getMonth() - 1)
        const dateRange = {
          start: monthAgo,
          end: new Date()
        };
        this.shortcut = 'm';
        this.$emit('changeDateRange', dateRange);
      },

      handleDPLastYear() {
        const yearAgo = new Date();
        yearAgo.setFullYear(yearAgo.getFullYear() - 1)
        const dateRange = {
          start: yearAgo,
          end: new Date()
        };
        this.shortcut = 'y';
        this.$emit('changeDateRange', dateRange);
      },

      handleDPClear() {
        this.shortcut = null;
        this.$emit('changeDateRange', null);
      },

      translate(key) {
        return i18n.t(key);
      }
    }
  }
</script>

<style scoped lang="scss">
  .date-range-picker-shortcuts{
    position: absolute;
    border: 1px solid #cbd5e0;
    background: #ffffff;
    width: 100%;
    bottom: 0px;
    z-index: 9999;
    border-top: none;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    -webkit-border-bottom-left-radius: 8px;
    -webkit-border-bottom-right-radius: 8px;
    margin-bottom: 0px;
  }
</style>
